/// <amd-module name="Repos/Tfvc/Views/ShelvesetDetails/ShelvesetDetailsViewService" />
import { IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { TfvcVersionType } from "Repos/Common/Contracts/Git";
import { tfvcVersionStringToVersionDescriptor } from "Repos/Common/Util/Version";
import { getShortChangeComment } from "Repos/Tfvc/Common/Utils/Comment";
import { ChangeDetailsViewService, IChangeDetailsViewService } from "Repos/Tfvc/Views/ChangeDetails/ChangeDetailsViewService";
import * as Resources from "Repos/Tfvc/Views/ShelvesetDetails/Resources";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IShelvesetDetailsData } from "./Contracts";
import { getDiscussionThreadService } from "./ShelvesetDiscussionThreadService";

export interface IShelvesetDetailsViewService extends IChangeDetailsViewService {}

class ShelvesetDetailsViewService extends ChangeDetailsViewService implements IChangeDetailsViewService {
    public getHeaderMenuItems(smallScreen: boolean): IHeaderCommandBarItem[] | undefined {
        return undefined;
    }

    public getDocumentTitle() {
        return format(Resources.DocumentTitleFormat, this.id, this.shortComment);
    }

    protected getChangeName(): string {
        return Resources.Shelveset;
    }

    protected getDiscussionService(): IArtifactDiscussionThreadService {
        return getDiscussionThreadService(this.pageContext);
    }

    public getVersionType(): TfvcVersionType {
        return TfvcVersionType.Shelveset;
    }

    protected initializeFields(shelvesetData: IShelvesetDetailsData): void {
        const { comment, creationDate, owner, ownerDisplayName, ownerId, ownerRef, shelvesetName, version } = shelvesetData;
        this.id = tfvcVersionStringToVersionDescriptor(version).version;
        this.defaultText = shelvesetName;
        this.owner = ownerRef || ({ id: ownerId, uniqueName: owner, displayName: ownerDisplayName } as IdentityRef);
        this.checkinDate = creationDate;
        this.fullComment = comment || this.getDefaultChangeText();
        this.shortComment = getShortChangeComment(this.fullComment);
    }
}

const serviceName = "IShelvesetDetailsViewService";
export function getShelvesetViewService(pageContext: IVssPageContext): IShelvesetDetailsViewService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ShelvesetDetailsViewService });
